import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice";
import loaderReducer from "./features/loaderSlice";
// import languageReducer from "./features/languageSlice";

// import skillReducer from "./features/skillSlice";
import titleReducer from "./features/titleSlice";
// import astrologerReducer from "./features/astrologerSlice";
// import userReducer from "./features/userSlice";
// import bannerReducer from "./features/bannerSlice";
// import blogReducer from "./features/blogSlice";
// import categoryReducer from "./features/categorySlice";
// import productReducer from "./features/productSlice";
// import pujaReducer from "./features/pujaSlice";
// import subAdminReducer from "./features/subAdminSlice";
// import callHistoryReducer from "./features/callHistorySlice";
// import gstReducer from "./features/gstSlice";
// import giftReducer from "./features/giftSlice";
// import siteSettingReducer from "./features/siteSettingSlice";
// import chadawaReducer from "./features/chadawaSlice";
// import chadawabookinglistReducer from "./features/chadawabookinglistSlice";
// import notificationReducer  from "./features/notificationSlice";
// import rechargeOfferReducer from "./features/rechargeSlice"
// import queryformReducer from "./features/queryformSlice"
// import walletReducer from './features/walletSlice';
// import inactiveUserLogsReducer  from "./features/inactiveUserLogsSlice"
// import astrologerRequestReducer from "./features/astrologerRequestSlice"
// import productBookingListReducer  from "./features/productBookingListSlice";
import jkmQueryReducer from "./features/jkmQuerySlice";


export const store = configureStore({
  reducer: {
    loader: loaderReducer,
    auth: authReducer,
    // languages: languageReducer,
    // skills: skillReducer,
    title: titleReducer,
    // astrologers: astrologerReducer,
    // users: userReducer,
    // banners: bannerReducer,
    // blogs: blogReducer,
    // categories: categoryReducer,
    // products: productReducer,
    // pujas: pujaReducer,
    // chadawa: chadawaReducer,
    // chadawabookinglist: chadawabookinglistReducer,
    // subAdmins: subAdminReducer,
    // callHistorys: callHistoryReducer,
    // gsts: gstReducer,
    // gifts: giftReducer,
    // siteSettings: siteSettingReducer,
    // notifications: notificationReducer,
    // rechargeOffer : rechargeOfferReducer,
    // queryform : queryformReducer,
    // wallet: walletReducer,
    // inactiveUserLogs: inactiveUserLogsReducer,
    // astrologerSignup: astrologerRequestReducer,
    // productBookingList: productBookingListReducer,
    jkmQueries: jkmQueryReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
